import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router";

// Creates a callback that navigates to "to" when called
export default function useNavigateCallback(
  to?: string,
  options?: NavigateOptions
): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    if (to !== undefined) {
      navigate(to, options);
    }
  }, [to, navigate, options]);
}
